import { selectorFamily, atom } from 'recoil';
import { PassingsService } from 'api';
// Increments by offset * paginationOffset
export const passingsPagination = atom({
  key: 'passingsPagination',
  default: {
    max: 10,
    offset: 0
  }
});
export const getPassingsForObe = selectorFamily({
  key: 'getPassingsForObe',
  get: obeNumber => async ({
    get
  }) => {
    let obePassings = {};
    if (!obeNumber) return obePassings;
    const paginationProps = get(passingsPagination);
    try {
      obePassings = await PassingsService.getPassingsForObe({
        obeNumber,
        body: paginationProps
      });
      return obePassings;
    } catch (e) {
      console.error(e);
    }
    return obePassings;
  }
});